import React from 'react';
import { Phone, FileSignature } from 'lucide-react';
import PageShell from '@/components/PageShell';
import SEO from '@/components/SEO';
import { useLanguage } from '@/i18n/LanguageContext';
import { track } from '@/lib/analytics';

const Emergency = () => {
  const { lang, t } = useLanguage();
  return (
    <PageShell trackPage="/emergency">
      <SEO title="24/7 Emergency Bail Bonds | Amigo's Bail Bonds | Montgomery County" description="Arrested right now? Amigo's Bail Bonds is available 24/7 for immediate, confidential help across Montgomery County, TX." path="/emergency" />
      <section className="section section--void" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
        <div className="container text-center" style={{ maxWidth: 700 }}>
          <div className="badge badge-urgent mb-6" style={{ fontSize: '0.8rem', padding: '0.4rem 1rem' }}>{lang === 'es' ? 'AYUDA DE EMERGENCIA 24/7' : '24/7 EMERGENCY HELP'}</div>
          <h1 className="section-title" style={{ fontSize: 'clamp(2.2rem, 6vw, 3.6rem)' }}>{lang === 'es' ? 'ARRESTARON A ALGUIEN AHORA MISMO?' : 'SOMEONE ARRESTED RIGHT NOW?'}</h1>
          <p className="section-subtitle" style={{ margin: '0 auto 2.2rem' }}>{lang === 'es' ? 'No espere. Llame ahora o comience su solicitud en menos de 2 minutos.' : "Don't wait. Call now or start your request in under 2 minutes."}</p>
          <div className="flex gap-4" style={{ justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="tel:9368282500" className="btn-red" style={{ fontSize: '1.05rem', padding: '1.1rem 2.2rem' }} onClick={() => track('phone_click', { location: 'emergency_page' })} data-testid="emergency-call-btn"><Phone size={18} /> (936) 828-2500</a>
            <a href="/start-a-bond" className="btn-brass" style={{ fontSize: '1.05rem', padding: '1.1rem 2.2rem' }} data-testid="emergency-start-bond-btn"><FileSignature size={18} /> {t('hero.startBond')}</a>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default Emergency;
